import { logger } from "../utils/utils";
import api from "./apis/api";

class CaskMasterService {
  createCaskMaster(payload) {
    logger("CaskMasterService", "createCaskMaster");
    return api.caskmaster.createCaskMaster(payload);
  }

  updateCaskMaster(payload) {
    logger("CaskMasterService", "updateCaskMaster");
    return api.caskmaster.updateCaskMaster(payload?.caskId, payload?.payload);
  }

  getCaskMasterList(payload) {
    logger("CaskMasterService", "getCaskMasterList");
    return api.caskmaster.getCaskMasterList(payload);
  }
}

export default new CaskMasterService();
